import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  hash: '',
  code: '',
  language: 'ru',
  company: 'GD-LAB',
  role: '', // doctor, ...
  doctor_id: 0,
  user_id: 0,
  doctorName: '',
  bankName: '',
  bik: '',
  checkingAccount: '',
  correspondentAccount: '',
  inn: '',
  kpp: ''
};

export const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    setRoleDoctorName: (state, action) => {
      state.doctorName = action.payload
    },
    setDoctorId: (state, action) => {
      state.doctor_id = action.payload
    },
    setUserId: (state, action) => {
      state.user_id = action.payload
    },

    setHash: (state, action) => {
      state.hash = action.payload
    },

    setCode: (state, action) => {
      state.code = action.payload
    },

    setLanguage: (state, action) => {
      state.language = action.payload
    },
    setCompany: (state, action) => {
      state.company = action.payload
    },
    setRole: (state, action) => {
      state.role = action.payload
    },
    setBankName: (state, action) => {
      state.bankName = action.payload
    },
    setBik: (state, action) => {
      state.bik = action.payload
    },
    setCheckingAccount: (state, action) => {
      state.checkingAccount = action.payload
    },
    setCorrespondentAccount: (state, action) => {
      state.correspondentAccount = action.payload
    },
    setInn: (state, action) => {
      state.inn = action.payload
    },
    setKpp: (state, action) => {
      state.kpp = action.payload
    },
  },
});

export const {setUserId, setRoleDoctorName, setLanguage, setHash, setCode, setCompany, setRole, setDoctorId, setBankName, setBik, setCheckingAccount, setCorrespondentAccount, setInn, setKpp } = loginSlice.actions;

export const selectHash = (state) => state.login.hash;
export const selectCode = (state) => state.login.code;
export const selectLanguage = (state) => state.login.language;
export const selectCompany = (state) => state.login.company;
export const selectRole = (state) => state.login.role;
export const selectDoctorId = (state) => state.login.doctor_id;
export const selectRoleDoctorName = (state) => state.login.doctorName;
export const selectUserId = (state) => state.login.user_id;
export const selectBankName = (state) => state.login.bankName;
export const selectBik = (state) => state.login.bik;
export const selectCheckingAccount = (state) => state.login.checkingAccount;
export const selectCorrespondentAccount = (state) => state.login.correspondentAccount;
export const selectInn = (state) => state.login.inn;
export const selectKpp = (state) => state.login.kpp;

export default loginSlice.reducer;
